module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/bg_mv-sp-b3ba9521e2ba87a76d3294f6ecbf79da.jpg";